<template lang="pug">
div

  section.u-mt-md(v-for="(group,key) in $t('exploreItems')")
    .grid(v-if="group.main")
      .column.is-widescreen-5.u-mb-mi
        AppTitle.u-mb-xs(:title="group.main.title" tag="h2" )
        p.u-text-lg.u-mb-xs {{group.main.desc}}
        AppLink( :to="group.main.url" :title="group.main.cta" class="button-link  is-black is-small") {{group.main.cta}}
      .column.is-widescreen-7
        .grid.is-tablet-6
          .column.u-mb-sm(v-for="(item,key) in group.subs")
            h4: AppLink( :to="item.url" :title="item.title" ) {{item.title}}
            p {{item.desc}}
            //- AppLink( :to="item.url" :title="item.cta" class="button-link is-tiny is-black") {{item.cta}}
    .grid.is-widescreen-4.is-dsektop-6(v-else)
      .column.u-mb-sm(v-for="(item,key) in group.subs")
        h4: AppLink( :to="item.url" :title="item.title" ) {{item.title}}
        p {{item.desc}}
    .u-divider.u-mt-sm(v-if="key != 'random3'")



</template>

<script>
export default {
  name: 'Explore'
};
</script>

<style lang="stylus">
.exploreItem
  max-width: unitRes(400, 800)
</style>

<i18n>
{
  "en": {
    "exploreItems":{
      "company":{
        "main":{
          "title":"Company",
          "desc":"Our company started with a mission of changing cultures and impacting humanity through producing high quality products.",
          "cta":"Explore company",
          "url":"/company"
        },
        "subs":{
          "about":{
            "title":"About",
            "desc":"We are Baianat, Inc. A multidisciplinary company with a detail-oriented mentality supporting different types of businesses across industries and overseas. ",
            "cta":"Know more about us",
            "url":"/company/about"
          },
          "history":{
            "title":"History",
            "desc":"Through the years, we have passed by many events that shaped our identity in the present time.",
            "cta":"Discover our history",
            "url":"/company/history"
          },
          "story":{
            "title":"Story",
            "desc":"Read our story and know how the company has been formulated into its current shape.",
            "cta":"Read our story",
            "url":"/company/story"
          },
          "years":{
            "title":"Years",
            "desc":"And know more about the milestones, ups and downs of every year we have passed and the important lessons we learnt.",
            "cta":"Flip through our years",
            "url":"/company/years"
          },
          "partners":{
            "title":"Partners",
            "desc":"And along the way, we created partnerships with people who would support us thrive in the digital era.",
            "cta":"See our partners",
            "url":"/company/partners"
          },
          "branches":{
            "title":"Branches",
            "desc":"See the branches near you around the world and come drink some tea with us.",
            "cta":"See our branches",
            "url":"/company/branches"
          },
          "follow":{
            "title":"Follow",
            "desc":"Or follow us on our social media channels and stay updated with information that are most relevant to you.",
            "cta":"Our social media channels",
            "url":"/follow"
          },
          "now":{
            "title":"Now",
            "desc":"Discover what’s happening moment by moment with real time updates from our teams across socials.",
            "cta":"Our social media channels",
            "url":"/now"
          },
          "blog":{
            "title":"Blog",
            "desc":"And if you are looking for a technical articles that help you better manage your business, we created our blog to support visionaries and entrepreneurs.",
            "cta":"Read our blog",
            "url":"/blog"
          },
          "press":{
            "title":"Press",
            "desc":"You can get to know our latest news and what’s happening inside the company through our press release.",
            "cta":"Explore press",
            "url":"/press"
          },
          "events":{
            "title":"Events",
            "desc":"To transmit our messages and better engage with the community, we created events through which we can meet you face to face.",
            "cta":"See our events",
            "url":"/events"
          },
          "work":{
            "title":"Work",
            "desc":"Operating across these various industries added to our world view and made us gain partners that we are proud to call family members today.",
            "cta":"See our Work",
            "url":"/work"
          },
          "brands":{
            "title":"Brands",
            "desc":"Starting from internal needs and out of an innovation rush,we founded ventures that operates in a variety of fields and supports different end users.",
            "cta":"Explore our brands",
            "url":"/brands"
          }
        }
      },
      "legal":{
        "main":{
          "title":"Legal",
          "desc":"Our legal contains all the policies that govern our online presence and helps us provide you with a better website experience.",
          "cta":"Explore legal",
          "url":"/legal"
        },
        "subs":{
          "privacy-policy":{
            "title":"Privacy policy",
            "desc":"We respect your information privacy so we tailored our privacy policy to help you understand everything related to the information we collect, why we collect it and what we do with it.",
            "cta":"Read our privacy policy",
            "url":"/legal/privacy-policy"
          },
          "terms-of-service":{
            "title":"Terms and conditions",
            "desc":"Know more about the guidelines that govern the way we provide our services and collaborate in projects.",
            "cta":"Read our terms of service",
            "url":"/legal/terms-of-service"
          },
          "recruitment-privacy-policy":{
            "title":"Recruitment policy",
            "desc":"Take a look at the guidelines that govern our hiring process and the information we collect during the onboarding process.",
            "cta":"Read our recruitment policy",
            "url":"/legal/recruitment-privacy-policy"
          },
          "copyrights":{
            "title":"Copyrights policy",
            "desc":"The licenses that govern Baianat content, resources and all the production we do in house.",
            "cta":"Read our copyright policy",
            "url":"/legal/copyrights"
          },
          "dmca":{
            "title":"DMCA",
            "desc":"Report your concerns regarding the copyrights or trademarks infringements or any misuse of your brand content.",
            "cta":"Read our DMCA",
            "url":"/legal/dmca"
          },
          "privacy-updates":{
            "title":"Privacy updates",
            "desc":"See the latest updates we have made regarding our legality and terms of service.",
            "cta":"See legal updates",
            "url":"/legal/privacy-updates"
          }
        }
      },
      "culture":{
        "main":{
          "title":"Culture",
          "desc":"Our culture is the main drive behind our actions.It consists of the values and principles that we proudly hold and distinguish us as Baianaters.",
          "cta":"Explore culture",
          "url":"/culture"
        },
        "subs":{
          "moments":{
            "title":"Moments",
            "desc":"We enjoy playing everyday and creating moments that tie us together and reminds us of the good times later on when we see it.",
            "cta":"See our moments ",
            "url":"/moments"
          },
          "manifesto":{
            "title":"Manifesto",
            "desc":"Through our years of experience, we found insights that shaped our future vision and made our manifesto.",
            "cta":"Read our manifesto",
            "url":"/culture/manifesto"
          },
          "approach":{
            "title":"Approach",
            "desc":"We developed our own way of producing high quality products so we can pour our souls into every project.",
            "cta":"See our approach ",
            "url":"/culture/approach"
          },
          "values":{
            "title":"Values",
            "desc":"The core values behind our culture that unit every player in Baianat and ensures consistency in actions.",
            "cta":"Know more",
            "url":"/culture/values"
          },
          "standards":{
            "title":"Standards",
            "desc":"Discover the pillars that drive our attitudes and everyday interactions inside Baianat.",
            "cta":"Know more",
            "url":"/culture/standards"
          }
        }
      },
      "careers":{
        "main":{
          "title":"Careers",
          "desc":"Know more about Baianat hiring process, the teams inside and the perks of becoming a Baianater.",
          "cta":"Explore careers",
          "url":"/careers"
        },
        "subs":{
          "perks":{
            "title":"Perks",
            "desc":"Explore the benefits that you will gain by joining Baianat team.",
            "cta":"See the perks",
            "url":"/careers/perks"
          },
          "journey":{
            "title":"Journey",
            "desc":"And know more about the hiring process starting from sending your email until you grab a chair and start building up solutions with us.",
            "cta":"See our hiring process",
            "url":"/careers/journey"
          },
          "opportunities":{
            "title":"Opportunities",
            "desc":"And as the family grows, we are always looking for more players. See the latest opportunities and hunt your spot.",
            "cta":"See open opportunities",
            "url":"/careers/opportunities"
          },
          "teams":{
            "title":"Teams",
            "desc":"See our teams and choose your side of the game. Learn more on our operations and how we work together.",
            "cta":"See open opportunities",
            "url":"/teams"
          }
        }
      },
      "support":{
        "main":{
          "title":"Care",
          "desc":"Get the care you need whenever you want through various communication channels with Baianat team.",
          "cta":"Explore care",
          "url":"/care"
        },
        "subs":{
          "knowledgebase":{
            "title":"Knowledge base",
            "desc":"To cut off the hassle for you, we created a knowledge base with the most frequent questions so you can easily look up what you need.",
            "cta":"Knowledge base",
            "url":"/knowledgebase"
          },
          "contact":{
            "title":"Contact us",
            "desc":"And in case you have further questions we would be glad to support you through email, phone or contact form.",
            "cta":"Contact",
            "url":"/contact"
          },
          "chat":{
            "title":"Live chat",
            "desc":"Chat with Baianat team directly and let us help you with your current issues and concerns.",
            "cta":"Chat now",
            "url":"/cc"
          },
          "cc":{
            "title":"Customer care",
            "desc":"If you have a current project that you want to track, we would be glad to hear from you on customer care.",
            "cta":"Go to CC",
            "url":"/cc"
          },
          "infringement":{
            "title":"Infringement",
            "desc":"And in case you are concerned about a trademark or copyrights violation, report it immediately through our infringement form.",
            "cta":"Report infringement",
            "url":"/infringement"
          },
          "feedback":{
            "title":"Feedback",
            "desc":"We are always happy to hear you suggestions, questions and concerns as we believe that two minds can always think better than one :)",
            "cta":"Send your feedback",
            "url":"/feedback"
          },
          "ordering":{
            "title":"Ordering",
            "desc":"Having a new project? Use our ordering form to send us your requirements and kick off the project. ",
            "cta":"Send your order",
            "url":"/ordering"
          }
        }
      },
      "impact":{
        "main":{
          "title":"Impact",
          "desc":"We believe that it's our responsibility to support the community we are part of through initiatives and activities.",
          "cta":"Explore impact",
          "url":"/impact"
        },
        "subs":{
          "initiatives":{
            "title":"Initiatives",
            "desc":"Our initiatives range from charity to education and women empowerment with one main target in mind, imacapting humanity.",
            "url":"/impact/initiatives"
          },
          "stories":{
            "title":"Stories",
            "desc":"Changing the world can’t be done by us only. See the heroes behind the scenes who are contributing to a better world with us as well.",
            "url":"/impact/stories"
          },
          "reports":{
            "title":"Reports",
            "desc":"Track our progress every year by numbers and facts and discover our performance in our areas of action.",
            "url":"/impact/reports"
          },
          "responsibility":{
            "title":"Responsibility",
            "desc":"We strive for a better community, sustainable environment and better living conditions for people by aligning what we do with the UN goals.",
            "url":"/impact/responsibility"
          },
          "volunteering":{
            "title":"Volunteering",
            "desc":"Changing reality by hand and donating hours for good causes that would spread awareness and support our goal of boosting humanity.",
            "url":"/impact/volunteering"
          }
        }
      },
      "capabilities":{
        "main":{
          "title":"Capabilities",
          "desc":"Discover our Capabilities process, the industries we support and the services we provide for a wide range of clients.",
          "cta":"Explore Capabilities",
          "url":"/capabilities"
        },
        "subs":{
          "industries":{
            "title":"Industries",
            "desc":"See some of the industries we support and how we collaborate with our clients to create customized solutions. ",
            "cta":"Discover the industries",
            "url":"/industries"
          },
          "services":{
            "title":"Services",
            "desc":"We work in the fields of business, design, development and technology to provide our partners with a holistic services view.",
            "cta":"Discover our services",
            "url":"/services"
          },
          "solutions":{
            "title":"Solutions",
            "desc":"We support you with digital solutions that meet your business needs and help you better connect with your customers.",
            "cta":"Discover our platforms",
            "url":"/solutions"
          }
        }
      },
      "labs":{
        "main":{
          "title":"Labs",
          "desc":"See the ideas we came up with during our production processes and explore our materials in design, business, development and technology.",
          "cta":"Explore Labs",
          "url":"/labs"
        },
        "subs":{
          "insights":{
            "title":"Insights",
            "desc":"Explore Baianat insights and inventions in both business and creative fields. Get a glimpse into the latest done inside our kitchen.",
            "cta":"Go Insights",
            "url":"/insights"
          },
          "backstage":{
            "title":"Backstage",
            "desc":"For every design project, there’s a whole story behind the scenes. Discover the early versions and walk the concept development journey with us.",
            "cta":"Go backstage",
            "url":"/backstage"
          },
          "experiments":{
            "title":"Experiments",
            "desc":"Discover the space where we code outside of the box to create solutions that contribute to humanity and open source community.",
            "cta":"See our experiments",
            "url":"/experiments"
          },
          "open-source":{
            "title":"Opensource",
            "desc":"Solving the repetition problem through libraries in both mobile and web to accelerate your coding progress.",
            "cta":"Explore our open source",
            "url":"/opensource"
          },
          "resources":{
            "title":"Resources",
            "desc":"And since we know that starting from a blank artboard in boring and time consumption, we created resources to support designers through their creative process.",
            "cta":"Explore our resources ",
            "url":"/resources"
          },
          "tools":{
            "title":"Tools",
            "desc":"To scale your project progress, we created handy tools that help designers, developers and strategists better handle their operations.",
            "cta":"Explore our tools",
            "url":"/tools"
          }
        }
      },
      "learn":{
        "main":{
          "title":"Learn",
          "desc":"Providing intensive and close learning experience through long term and short term training opportunities. ",
          "cta":"Explore learn",
          "url":"/learn"
        },
        "subs":{
          "academy":{
            "title":"Academy",
            "desc":"Since we wanted to keep the community aware of what we do moment by moment, we founded academy to put our latest discoveries in consolidated learning paths.",
            "url":"/academy"
          },
          "internships":{
            "title":"Internships",
            "desc":"Also, Baianat internships program was made for anyone who wants a close experience working side by side with us on real cases.",
            "cta":"Explore our internships",
            "url":"/internships"
          },
          "workshops":{
            "title":"Workshops",
            "desc":"And to discuss technical topics in detail, we created workshops that are held in our headquarter for students and techies.",
            "cta":"Explore workshops",
            "url":"/workshops"
          },
          "books":{
            "title":"Books",
            "desc":"We created our books to contain the essentials of every field for a more in depth knowledge and technical details.",
            "cta":"Read our books",
            "url":"/books"
          }
        }
      },
      "programs":{
        "main":{
          "title":"Programs",
          "desc":"Planning opportunities where we can engage better with the community and spread awareness through Baianat programs.",
          "cta":"Explore programs",
          "url":"/programs"
        },
        "subs":{
          "ambassadors":{
            "title":"Ambassadors",
            "desc":"As we wanted to be around you in campus, our ambassadors program was created for students from around the world who want to help us spread awareness. ",
            "cta":"Explore ambassadors",
            "url":"/programs/ambassadors"
          },
          "seeders":{
            "title":"Seeders",
            "desc":"And for professionals who share us the same passion for authenticity, we created seeders program so we can collaborate together in events and initiatives. ",
            "cta":"Explore seeders",
            "url":"/programs/seeders"
          }
        }
      },
      "brand":{
        "main":{
          "title":"Brand",
          "desc":"Our brand was designed with the concept of functionality and abstraction in mind, however we come in almost every color.",
          "cta":"Explore brand",
          "url":"/brand"
        },
        "subs":{
          "artifacts":{
            "title":"Artifacts",
            "desc":"Since we believe in iterations and that today's' first drafts are just an inspiration for tomorrow's big projects.",
            "cta":"Enjoy the Artifacts",
            "url":"/brand/artifacts"
          },
          "downloads":{
            "title":"Downloads",
            "desc":"Get all Baianat brand assets in the format needed to keep the brand consistent across every channel.",
            "cta":"Enjoy the downloads",
            "url":"/brand/downloads"
          },
          "guideline":{
            "title":"Guideline",
            "desc":"Read through the rules that govern our brand asset usage starting from logo placement to lockups.",
            "cta":"Enjoy the Guideline",
            "url":"/brand/guideline"
          }
        }
      },
      "random3":{
        "subs":{
          "homer":{
            "title":"Homer",
            "desc":"And to keep the conversation running, we created a weekly newsletter through which you can subscribe to the fields you are most interested in.",
            "cta":"Subscribe in Homer",
            "url":"/homer"
          },
          "wave":{
            "title":"Wave",
            "desc":"And to make collaboration easier, we created wave to help us communicate better with clients and with each other.",
            "cta":"Discover Wave",
            "url":"/wave"
          }
        }
      }
    }
  },
  "ar": {
    "exploreItems":{
      "company":{
        "main":{
          "title":"الشركة",
          "desc":"تحمل شركتنا على عاتقها مهمة تغيير الثقافات والتأثير على البشرية بالإيجاب من خلال إنتاج منتجات عالية الجودة.",
          "cta":"اكتشف الشركة.",
          "url":"/company"
        },
        "subs":{
          "about":{
            "title":"عن بيانات",
            "desc":"تعرف علينا من خلال الثقافة والمبادئ التي نسير عليها والمنهج الذي نتبعه لخلق منتجات فريدة.",
            "cta":"اقرأ المزيد عنا",
            "url":"/company/about"
          },
          "history":{
            "title":"التاريخ",
            "desc":"ألقِ نظرة على تاريخ بيانات والأحداث الهامة والقصص والخبرات التى شكلت ما نحن عليه الآن.",
            "cta":"اقرأ تاريخنا",
            "url":"/company/history"
          },
          "story":{
            "title":"القصة",
            "desc":"اقرأ قصتنا وتعرف على أهم الأحداث ونقاط التحول التي مررنا بها على مر السنوات.",
            "cta":"اقرأ قصتنا",
            "url":"/company/story"
          },
          "years":{
            "title":"السنوات",
            "desc":"تعرف على سنوات بيانات منذ البداية وحتى الآن واعرف الفترات الصعود والهبوط خلال مشوارنا وأهم الدروس التي تعلمناها.",
            "cta":"شاهد سنواتنا المختلفة",
            "url":"/company/years"
          },
          "partners":{
            "title":"الشركاء",
            "desc":"على طول الطريق أنشأنا شراكات مع أشخاص مختلفين قاموا بدعمنا خلال رحلتنا في العصر الرقمي.",
            "cta":"تعرف على شركائنا",
            "url":"/company/partners"
          },
          "branches":{
            "title":"الفروع ",
            "desc":"شاهد فروع بيانات القريبة منك حول العالم ويمكنك الانضمام إلينا وتناول الشاي سويا :)",
            "cta":"تعرف على فروعنا",
            "url":"/company/branches"
          },
          "follow":{
            "title":"تابعنا",
            "desc":"تعرف على جميع حساباتنا على وسائل التواصل الإجتماعي وكن على إطلاع على جميع المعلومات التي تهمك وذات صلة بمجالك.",
            "cta":"حسابات التواصل الإجتماعي لدينا",
            "url":"/follow"
          },
          "now":{
            "title":"الآن",
            "desc":"اكتشف ماذا يحدث لحظة بلحظة من خلال التحديثات التي ينشرها فريق بيانات عبر مواقع التواصل الإجتماعي.",
            "cta":"Our social media channels",
            "url":"/now"
          },
          "blog":{
            "title":"المدونة",
            "desc":"إذا كنت تبحث عن مقالات تقنية تساعدك على إدارة أعمالك بشكل أفضل، فقد أنشأنا مدونتنا لدعم أصحاب الرؤى ورجال الأعمال.",
            "cta":"اقرأ المدونة",
            "url":"/blog"
          },
          "press":{
            "title":"الصحافة",
            "desc":"يمكنك التعرف على آخر أخبارنا وما يحدث داخل الشركة من خلال بياناتنا الصحفية.",
            "cta":"اقرأ صحافة بيانات",
            "url":"/press"
          },
          "events":{
            "title":"الفعاليات",
            "desc":"من أجل نقل رسائلنا وخبراتنا وجهًا لوجه مع الجميع أنشأنا الفعاليات الخاصة بنا لمزيد من التواصل مع المجتمع.",
            "cta":"تعرف على فعاليات بيانات.",
            "url":"/events"
          },
          "work":{
            "title":"أعمالنا",
            "desc":"نعمل عبر الصناعات المختلفة من أجل إضافة نظرتنا إلى العالم ونكسب شركاء جدد كل يوم ولكي ينضم إلى أسرتنا المزيد من شركاء النجاح.",
            "cta":"شاهد المشاريع",
            "url":"/work"
          },
          "brands":{
            "title":"علاماتنا",
            "desc":"أسسنا علاماتنا التجارية التي تخدم في مجموعة متنوعة من المجالات وتدعم مختلف المستخدمين النهائيين؛ نتيجة للحاجة الداخلية التي لدينا وبدافع الابتكار.",
            "cta":"استكشف علاماتنا.",
            "url":"/brands"
          }
        }
      },
      "legal":{
        "main":{
          "title":"القوانين",
          "desc":"تحتوي القوانين على جميع السياسات التي تحكم وجودنا عبر الإنترنت وتساعدنا على التعاون معك بشكل أفضل.",
          "cta":"اكتشف القوانين.",
          "url":"/legal"
        },
        "subs":{
          "privacy-policy":{
            "title":"سياسة الخصوصية",
            "desc":"نحترم خصوصية المعلومات الخاصة بك، لذلك قمنا بصياغة سياسة الخصوصية من أجل مساعدتك على فهم كل شيء متعلق بالمعلومات التي نجمعها منك ولماذا نجمعها وماذا نفعل بها.",
            "cta":"تعرف على سياسة الخصوصية",
            "url":"/legal/privacy-policy"
          },
          "terms-of-service":{
            "title":"شروط الخدمة",
            "desc":"تعرف على المزيد حول الإرشادات التي تحكم الطريقة التي نقدم خدماتنا بها وكيف نتعاون سويًا لإنجاز المشاريع.",
            "cta":"تعرف على شروط الخدمة",
            "url":"/legal/terms-of-service"
          },
          "recruitment-privacy-policy":{
            "title":"سياسة التوظيف",
            "desc":"تعرف على السياسة التي تحكم عملية التوظيف لدينا وما هي المعلومات التي نجمعها منك على طول الطريق.",
            "cta":"اقرأ سياسة التوظيف",
            "url":"/legal/recruitment-privacy-policy"
          },
          "copyrights":{
            "title":"سياسة حقوق التأليف والنشر",
            "desc":"تعرف على التراخيص التي تحكم محتوي بيانات والمصادر وجميع الإنتاج الذي نقوم به.",
            "cta":"اقرأ سياسة حقوق التأليف والنشر",
            "url":"/legal/copyrights"
          },
          "dmca":{
            "title":"قانون الألفية للملكية الرقمية",
            "desc":"قم بالإبلاغ عن مخاوفك سواء كانت بشأن انتهاك حقوق التأليف والنشر أو العلامة التجارية أو أس سواء استخدام لمحتوى علامتك التجارية.",
            "cta":"اقرأ قانون الألفية للملكية الرقمية",
            "url":"/legal/dmca"
          },
          "privacy-updates":{
            "title":"تحديثات الخصوصية",
            "desc":"اطلع على آخر التحديثات التي قمنا بها في سياسة الخصوصية لدينا.",
            "cta":"اقرأ تحديثات الخصوصية",
            "url":"/legal/privacy-updates"
          }
        }
      },
      "culture":{
        "main":{
          "title":"الثقافة",
          "desc":"ثقافتنا هي الدافع الرئيسي وراء أفعالنا، وهي تتكون من قيمنا ومبادئنا التي نعتز ونفخر بها والتي تقود كل جانب من جوانب حياتنا.",
          "cta":"اكتشف ثقافتنا.",
          "url":"/culture"
        },
        "subs":{
          "moments":{
            "title":"اللحظات",
            "desc":"نستمتع باللعب كل يوم سويًا ونخلق لحظات تربطنا ببعضنا البعض وتذكرنا بالأيام الجيدة التي مررنا بها معًا عندما نشاهدها.",
            "cta":"شاهد لحظاتنا",
            "url":"/moments"
          },
          "manifesto":{
            "title":"الميثاق",
            "desc":"من خلال التجارب التي مررنا بها على مر السنوات شكلنا الرؤية التي تجعلنا نرى العالم ونقود من خلالها أعمالنا.",
            "cta":"أقرأ ميثاقنا.",
            "url":"/culture/manifesto"
          },
          "approach":{
            "title":"المنهجية",
            "desc":"قمنا بتطوير طريقتنا الخاصة في إنتاج المنتجات والخدمات التي نقدمها من أجل أن تكون فريدة من نوعها وتتمتع بجودة عالية.",
            "cta":"تعرف على منهجنا ",
            "url":"/culture/approach"
          },
          "values":{
            "title":"القيم",
            "desc":"المبادئ الأساسية خلف ثقافة بيانات التي توحد بين جميع اللاعبين وكذلك تؤكد على الاتساق في الأفعال في مختلف المواقف.",
            "cta":"اعرف المزيد",
            "url":"/culture/values"
          },
          "standards":{
            "title":"المعايير",
            "desc":"اكتشف الركائز الأساسية التي تقود الأفعال المختلفة في كل تفاعل من التفاعلات التي تتم بداخل بيانات.",
            "cta":"Know more",
            "url":"/culture/standards"
          }
        }
      },
      "careers":{
        "main":{
          "title":"الوظائف",
          "desc":"اعرف المزيد عن خطوات عملية في بيانات والفرق الموجودة في الداخل والفرص المتاحة وكذلك الامتيازات التي سوف تتمتع بها.",
          "cta":"اكتشف وظائف بيانات",
          "url":"/careers"
        },
        "subs":{
          "perks":{
            "title":"الامتيازات",
            "desc":"اكتشف الفوائد التي ستحصل عليها عندما تنضم إلى فريق بيانات وتعرف كيف ستنمو في حياتك المهنية.",
            "cta":"اكتشف امتيازات بيانات",
            "url":"/careers/perks"
          },
          "journey":{
            "title":"الرحلة",
            "desc":"تعرف على المزيد حول عملية التوظيف التي تبدأ من خلال إرسال بريد إلكتروني حتى تحصل على كرسي وتنخرط في العمل معنا.",
            "cta":"تعرف على عملية التوظيف لدينا",
            "url":"/careers/journey"
          },
          "opportunities":{
            "title":"الفرص المتاحة",
            "desc":"مع نمو الأسرة نبحث عن المزيد من اللاعبين الذي يتشابهون معنا. تعرف على أحدث الفرص المتاحة وابحث عن مكانك.",
            "cta":"تعرف على فرق بيانات",
            "url":"/careers/opportunities"
          },
          "teams":{
            "title":"الفرق",
            "desc":"اكتشف المزيد عن الفرق الموجودة داخل بيانات واختار جانبًا من اللعبة، تعرف على  المزيد حول عملياتنا وكيف نعمل معًا.",
            "cta":"تعرف على فرق بيانات",
            "url":"/teams"
          }
        }
      },
      "support":{
        "main":{
          "title":"الدعم",
          "desc":"احصل على الدعم الذي تحتاج إليه من فريق بيانات في أي وقت من خلال قنوات التواصل المختلفة.",
          "cta":"اكتشف الفرص المتاحة",
          "url":"/care"
        },
        "subs":{
          "knowledgebase":{
            "title":"قاعدة المعرفة",
            "desc":"لإزالة المتاعب التي تمر بها والتخلص من الارتباك الذي ينتابك، أنشأنا قاعدة المعرفة من أجل الأسئلة الأكثر شيوعًا حتى تتمكن من البحث بسهولة ومعرفة كل ما يشغل بالك.",
            "cta":"قاعدة المعرفة",
            "url":"/knowledgebase"
          },
          "contact":{
            "title":"اتصل بنا",
            "desc":"في حال كان لديك المزيد من الأسئلة، يسعدنا تقديم الدعم لك عبر البريد الإلكتروني أو الهاتف أو نموذج اتصل بنا.",
            "cta":"اتصل بنا.",
            "url":"/contact"
          },
          "chat":{
            "title":"الدردشة الحية",
            "desc":"تحدث مع فريق بيانات مباشرة ودعنا نساعدك على حل مشكلاتك أو الحصول على إجابة لاستفساراتك.",
            "cta":"تحدث الآن!",
            "url":"/cc"
          },
          "cc":{
            "title":"خدمة العملاء",
            "desc":"إذا كان لديك مشروع حالي تريد معرفة حالته، فيسعدنا أن نستمع إليك في أي وقت.",
            "cta":"إذهب إلى خدمة العملاء.",
            "url":"/cc"
          },
          "infringement":{
            "title":"الانتهاكات",
            "desc":"إذا كنت قلقًا بشأن انتهاك علامة تجارية أو حقوق التأليف والنشر فأبلغ عنها فورًا من خلال نموذج الانتهاك",
            "cta":"الإبلاغ عن انتهاك ",
            "url":"/infringement"
          },
          "feedback":{
            "title":"ارسل اقتراحك",
            "desc":"يسعدنا دائمًا أن نستمع إلى الاقتراحات والأسئلة والمخاوف والشكاوي؛ لأننا نؤمن أن عقلان يفكران أفضل من عقل واحد.",
            "cta":"ارسل اقتراحاتك.",
            "url":"/feedback"
          },
          "ordering":{
            "title":"طلب خدمة",
            "desc":"هل لديك مشروع جديد؟ استخدم نموذج الطلب لإرسال متطلباتك إلينا من أجل التفكير والبدء في المشروع.",
            "cta":"أرسل طلبك",
            "url":"/ordering"
          }
        }
      },
      "impact":{
        "main":{
          "title":"التأثير",
          "desc":"نؤمن أن دعم المجتمع يندرج تحت مسؤوليتنا؛ لأننا جزء منه لذلك نوفر المبادرات والأنشطة المتنوعة.",
          "cta":"اكتشف التأثير",
          "url":"/impact"
        },
        "subs":{
          "initiatives":{
            "title":"المبادرات",
            "desc":"تتراوح المبادرات التي نقوم بها ما بين الأعمال الخيرية والتعليم وتمكين المرأة مع وضع هدف رئيسي واحد في الاعتبار وهو التأثير في البشرية.",
            "url":"/impact/initiatives"
          },
          "stories":{
            "title":"القصص",
            "desc":"تغيير العالم لا يمكن أن يتم من جهتنا فقط. تعرف على الأبطال خلف الكواليس الذين يساهمون في خلق عالم أفضل بجوارنا.",
            "url":"/impact/stories"
          },
          "reports":{
            "title":"التقارير",
            "desc":"تعرف على التقدم الذي نحرزه كل عام من خلال الأرقام والتقارير واكتشف تطورات أدائنا في القضايا التي نتبناها.",
            "url":"/impact/reports"
          },
          "responsibility":{
            "title":"المسؤولية",
            "desc":"نسعى جاهدين من أجل خلق مجتمع أفضل وبيئة مستدامة وظروف معيشية مناسبة للناس من خلال مواءمة كل ما نقوم به مع أهداف الأمم المتحدة.",
            "url":"/impact/responsibility"
          },
          "volunteering":{
            "title":"التطوع",
            "desc":"نحاول تغيير الواقع بأيدينا ونتبرع بساعات من أوقاتنا من أجل نشر الوعي ودعم هدفنا الأساسي المتمثل في مساعدة البشرية.",
            "url":"/impact/volunteering"
          }
        }
      },
      "capabilities":{
        "main":{
          "title":"القدرات",
          "desc":"اكتشف القدرات لدينا، والصناعات التي ندعمها والخدمات التي نقدمها من أجل عملائنا.",
          "cta":"اكتشف قدراتنا",
          "url":"/Capabilities"
        },
        "subs":{
          "industries":{
            "title":"الصناعات",
            "desc":"اطلع على بعض الصناعات التي ندعمها وكيف نتعاون مع عملائنا من أجل إنشاء حلول مخصصة",
            "cta":"اكتشف الصناعات",
            "url":"/industries"
          },
          "services":{
            "title":"الخدمات",
            "desc":"نعمل في مجالات الأعمال التجارية والبرمجة والتكنولوجيا والتصميم من أجل تزويد شركائنا في النجاح برؤى شاملة",
            "cta":"اكتشف خدماتنا.",
            "url":"/services"
          },

          "solutions":{
            "title":"الحلول",
            "desc":"نساعدك من خلال منتجات رقمية تتلاقى مع احتياجات أعمالك و تساعدك فى التواصل بطريقة أمثل مع العملاء.",
            "cta":"Discover our platforms",
            "url":"/solutions"
          }
        }
      },
      "labs":{
        "main":{
          "title":"المختبرات",
          "desc":"شاهد الأفكار التي توصلنا إليها أثناء عمليات الإنتاج لدينا واستكشف موادنا في التصميم والأعمال التجارية والتطوير والتكنولوجيا.",
          "cta":"اكتشف المختبرات",
          "url":"/labs"
        },
        "subs":{
          "insights":{
            "title":"الرؤى",
            "desc":"اكتشف رؤي بيانات والاختراعات في مجالات الأعمال التجارية والإبداعية، وتعرف على أحدث ما قمنا به حتى الآن.",
            "cta":"Go Insights",
            "url":"/insights"
          },
          "backstage":{
            "title":"الكواليس",
            "desc":"لكل مشروع تصميمي هناك قصة كاملة خلف الكواليس. تعرف على الإصدارات المبكرة وشاهد رحلة تطور أفكارنا.",
            "cta":"شاهد ما يدور خلف الكواليس",
            "url":"/backstage"
          },
          "experiments":{
            "title":"التجارب",
            "desc":"اكتشف المساحة التي نقوم فيها بالبرمجة وكتابة الأكواد من أجل إنشاء حلول تساهم في مساعدة الإنسانية ومجتمع المصادر المفتوحة.",
            "cta":"شاهد تجاربنا",
            "url":"/experiments"
          },
          "open-source":{
            "title":"المصادر المفتوحة",
            "desc":"حاولنا حل مشكل التكرار من خلال إنشاء المكتبات لمطوري المواقع والتطبيقات من أجل تسريع عملية كتابة الكود.",
            "cta":"استكشف مصادرنا المفتوحة",
            "url":"/opensource"
          },
          "resources":{
            "title":"تصميمات مجانية ",
            "desc":"نعلم أنه البدء من ورقة فارغة في كل مرة ما هو إلا مضيعة للوقت، لهذا أنشأنا تصميمات مجانية لدعم المصممين خلال عملياتهم الإبداعية.",
            "cta":"استكشف المصادر ",
            "url":"/resources"
          },
          "tools":{
            "title":"الأدوات",
            "desc":"من أجل توسيع نطاق تقدم المشروعات، أنشأنا الأدوات لتكون مفيدة لكل من المصممين والمطورين والاستراتيجيين وتساعدهم على أداء عملياتهم بشكل أفضل.",
            "cta":"استكشف أدواتنا",
            "url":"/tools"
          }
        }
      },
      "learn":{
        "main":{
          "title":"التعلم",
          "desc":"احصل على تجربة تعلم مكثفة ودقيقة من خلال فرص التدريب طويلة وقصيرة الأجل.",
          "cta":"اكتشف التعلم",
          "url":"/learn"
        },
        "subs":{
          "academy":{
            "title":"الأكاديمية",
            "desc":"نظرًا لأننا نريد أن يكون المجتمع على دراية بكل ما نقوم به لحظة بلحظة، فقد أسسنا الأكاديمية من أجل وضع أحدث اكتشافاتنا في مسارات تعليمية.",
            "url":"/academy"
          },
          "internships":{
            "title":"التدريب الداخلي",
            "desc":"تم إنشاء برنامج بيانات للتدريب الداخلي لأولئك الذين يريدون تجربة العمل جنبًا إلى جنب معنا في حالات حقيقية.",
            "cta":"استكشف برنامج التدريب الداخلي لدينا.",
            "url":"/internships"
          },
          "workshops":{
            "title":"ورش العمل",
            "desc":"من أجل مناقشة الموضوعات الفنية بالتفصيل، أنشأنا ورش عمل تعقد في مقرنا الرئيسي للطلاب والتقنيين لنشر الوعي ومنحهم المزيد من المعرفة.",
            "cta":"استكشاف ورش العمل",
            "url":"/workshops"
          },
          "books":{
            "title":"الكتب",
            "desc":"أعددنا مجموعة من الكتب في مجالات التصميم والبيزنس والبرمجة والتكنولوجيا من أجل توفير المعلومات التقنية المفصلة.",
            "cta":"اقرأ كتب بيانات.",
            "url":"/books"
          }
        }
      },
      "programs":{
        "main":{
          "title":"البرامج",
          "desc":"التخطيط لكافة الفرص التي يمكن من خلالها التواصل مع المجتمع ونشر الوعي من خلال برنامج بيانات. ",
          "cta":"اكتشف البرامج",
          "url":"/programs"
        },
        "subs":{
          "ambassadors":{
            "title":"السفراء",
            "desc":"أردنا أن نكون حولك في الحرم الجامعي، لهذا أنشأنا برنامج السفراء للطلاب من جميع أنحاء العالم الذين يريدون مساعدتنا في نشر الوعي.",
            "cta":"تعرف على برنامج السفراء.",
            "url":"/programs/ambassadors"
          },
          "seeders":{
            "title":"الناشرون",
            "desc":"وللمحترفين والخبراء الذين يشاركوننا نفس الشغف أسسنا برنامج الناشرون لنتعاون معًا في الفعاليات والمبادرات.",
            "cta":"تعرف على برنامج الناشرون.",
            "url":"/programs/seeders"
          }
        }
      },
      "brand":{
        "main":{
          "title":"العلامة التجارية",
          "desc":"تم تصميم علاماتنا التجارية مع الأخذ في الاعتبار مفهوم الوظيفة والتجريد، ومع ذلك تأتى في كل لون تقريبًا.",
          "cta":"اكتشف علاماتنا التجارية",
          "url":"/brand"
        },
        "subs":{
          "artifacts":{
            "title":"المتعلقات",
            "desc":"أننا نؤمن بالمراجعات المستمرة وأن المسودة الأولى التي نقوم بها اليوم هي بداية لفكرة ملهمة للغد، لهذا أسسنا متعلقات بيانات لتطلع على كل المسودات التي ننتجها.",
            "cta":"شاهد خربشات بيانات.",
            "url":"/brand/artifacts"
          },
          "downloads":{
            "title":"تحميل العلامة التجارية",
            "desc":"احصل على جميع أصول علامة بيانات التجارية بالتنسيق الذي تحتاج إليه من أجل المحافظة على اتساق العلامة التجارية على كل قناة.",
            "cta":"Enjoy the downloads",
            "url":"/brand/downloads"
          },
          "guideline":{
            "title":"إرشادات العلامة التجارية",
            "desc":"تعرف على القوانين التي تحكم استخدام أصول علاماتنا التجارية بداية من استخدام الشعار وحتى الأماكن التي تضعها بها.",
            "cta":"Enjoy the Guideline",
            "url":"/brand/guideline"
          }
        }
      },
      "random3":{
        "subs":{
          "homer":{
            "title":"هومر",
            "desc":"للحفاظ على استمرار المحادثات، أنشأنا هومر لتوفير رسائل إخبارية أسبوعية في المجال ذي الصلة بك.",
            "cta":"اشترك في هومر!",
            "url":"/homer"
          },
          "wave":{
            "title":"ويف",
            "desc":"من أجل جعل التعاون أسهل، أنشأنا ويف لمساعدتنا على التواصل بشكل أفضل مع العملاء ومع الفريق وبعضه البعض.",
            "cta":"اكتشف ويف",
            "url":"/wave"
          }
        }
      }
    }
  }
}
</i18n>
